import { useAudio } from '@/hooks/use-audio';
import { useGuidePlayer } from '@/hooks/use-guide-player';
import { useCallback } from 'react';

/**
 * Toggles shared audio playback from a surface outside the player controls
 * (a page header), reporting the pause or resume to the open player's session
 * analytics first, as the player's own buttons do. Both the report and the
 * toggle read `mediaEl.paused`, so they cannot disagree.
 */
export function useTogglePlayback() {
    const { controls, mediaEl } = useAudio();
    const { trackPlaybackToggle } = useGuidePlayer();
    const { togglePlay } = controls;

    return useCallback(() => {
        if (!mediaEl) {
            return;
        }
        trackPlaybackToggle(mediaEl.paused ? 'play' : 'pause');
        togglePlay();
    }, [mediaEl, togglePlay, trackPlaybackToggle]);
}
